import React, {useEffect, useState} from "react";
import {Link as RouterLink, useSearchParams} from "react-router-dom";
import {Box, Button, Pagination, Paper, Stack} from "@mui/material";
import {EventList} from "../../components/event/EventList";
import {EventPageinatedResponse} from "../../data/events/EventPageinatedResponse";

export const EventListingArchivePage = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const page = parseInt(searchParams.get("page") ?? "1")
    const [eventListings, setEventListings] = useState<EventPageinatedResponse>({
        totalEvents: 1,
        totalPages: 1,
        events: []
    })

    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        searchParams.set("page", value.toString())
        setSearchParams(searchParams)
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`/api/event/${page}/archive`)
                const data = await response.json()
                setEventListings(data)
            } catch (error) {
                console.error('Error fetching events:', error)
            }
        };
        fetchData()
    }, [page])

    const totalPages = eventListings.totalPages

    return <Stack spacing={1}>
        <Paper variant={"outlined"} style={{
            marginTop: "16px",
            padding: "16px"
        }}>
            <EventList events={eventListings.events} canCreateEvents={false} />
            <Button component={RouterLink} to={`/events`} color="info">View Active</Button>
        </Paper>
        <Box sx={{justifyContent: "center", display: "flex", width: "100%", mt: 2}}>
            <Pagination color={'secondary'} count={totalPages} page={page} onChange={handleChange}/>
        </Box>
    </Stack>
}